import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="one-rm-calculator"
export default class extends Controller {
  static targets = ["weight", "reps", "result", "formula"];

  connect() {
    console.log("1RM Calculator controller connected");
    this.applyMedievalText(); // Apply medieval text on connect
    document.addEventListener(
      "theme:change",
      this.applyMedievalText.bind(this)
    ); // Listen for theme changes
    this.calculate(); // Initial calculation
  }

  disconnect() {
    document.removeEventListener(
      "theme:change",
      this.applyMedievalText.bind(this)
    );
  }

  calculate() {
    const weight = parseFloat(this.weightTarget.value);
    const reps = parseInt(this.repsTarget.value);

    if (isNaN(weight) || isNaN(reps) || weight <= 0 || reps <= 0) {
      this.resultTarget.textContent = "-";
      return;
    }

    let estimated1RM;
    if (reps === 1) {
      estimated1RM = weight; // If reps is 1, 1RM is the weight itself
    } else {
      // Brzycki Formula: Weight / (1.0278 - 0.0278 * Reps)
      estimated1RM = weight / (1.0278 - 0.0278 * reps);
    }

    // Round to 1 decimal place or show integer if whole number
    const rounded1RM = Math.round(estimated1RM * 10) / 10;
    this.resultTarget.textContent = Number.isInteger(rounded1RM)
      ? rounded1RM.toString()
      : rounded1RM.toFixed(1);
  }

  applyMedievalText() {
    const theme = document.documentElement.getAttribute("data-bs-theme");
    const elements = this.element.querySelectorAll("[data-medieval-text]");

    elements.forEach((element) => {
      if (!element.hasAttribute("data-original-text")) {
        element.setAttribute("data-original-text", element.textContent.trim());
      }
      if (theme === "medieval" && element.hasAttribute("data-medieval-text")) {
        element.textContent = element.getAttribute("data-medieval-text");
      } else {
        element.textContent = element.getAttribute("data-original-text");
      }
    });
    // Also update the formula text based on theme
    if (theme === "medieval") {
      this.formulaTarget.textContent =
        "(Calculated via the Ancient Brzycki Scroll)";
    } else {
      this.formulaTarget.textContent = "(Using Brzycki Formula)";
    }
  }
}
